import React, { useEffect, useState } from "react";
import { X, Share2 } from "lucide-react";
import api from "../lib/api";
import { SignalPulse } from "./SignalPulse";

export const openComposer = (text) => window.dispatchEvent(new CustomEvent("sovsig:compose", { detail: { text } }));

// One-time celebration card for a creator's member milestone (1, 10, 25, 50, 100, every 100).
export const BeaconMilestone = ({ accent = "#14A89A" }) => {
  const [m, setM] = useState(null);
  useEffect(() => { api.get("/beacon/mine/milestone").then((r) => setM(r.data.milestone)).catch(() => {}); }, []);
  if (!m) return null;
  const close = () => { api.post(`/beacon/mine/milestone/${m.id}/dismiss`).catch(() => {}); setM(null); };
  return (
    <div className="relative overflow-hidden border p-6 sm:p-8 mb-6 bg-[#121212] milestone-in" style={{ borderColor: accent + "66" }} data-testid="beacon-milestone-card">
      <div className="absolute inset-0 pointer-events-none milestone-shimmer" style={{ background: `radial-gradient(circle at 18% 50%, ${accent}33 0%, transparent 55%)` }} />
      <button type="button" onClick={close} aria-label="Close celebration" data-testid="beacon-milestone-close" className="absolute top-3 right-3 text-zinc-500 hover:text-white transition-colors"><X size={18} /></button>
      <div className="relative flex flex-col sm:flex-row sm:items-center gap-5 sm:gap-8">
        <div className="shrink-0 flex items-center gap-4">
          <div className="milestone-glow" style={{ filter: `drop-shadow(0 0 18px ${accent})` }}><SignalPulse size={54} inline /></div>
          <div className="font-display text-6xl leading-none" style={{ color: accent }} data-testid="beacon-milestone-number">{m.value}</div>
        </div>
        <div className="min-w-0">
          <h3 className="font-heading text-2xl text-white mb-1.5" data-testid="beacon-milestone-title">{m.card}</h3>
          <p className="font-body text-sm text-zinc-300 leading-relaxed mb-4" data-testid="beacon-milestone-message">{m.message}</p>
          <button type="button" onClick={() => { openComposer(m.share); close(); }} data-testid="beacon-milestone-share"
            className="inline-flex items-center gap-1.5 px-4 py-2 font-body text-sm font-medium text-[#0A0A0A] hover:brightness-110 transition-[filter]" style={{ background: accent }}>
            <Share2 size={14} /> Share this moment
          </button>
          <span className="block font-body text-[11px] text-zinc-600 mt-2">Opens a post you can edit, nothing is shared unless you choose to.</span>
        </div>
      </div>
    </div>
  );
};
